import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';
import { StoreProductDetailTileModel } from '@/types/StoreContextContentServerContract';
import ProductDetail from '@/shared/product/details/ui/ProductDetail.vue';
import useProductDetailTileModel from '@/shared/product/details/useProductDetailTileModel';
import { toRef } from 'vue';
import ProductDetailPurchase from '@/storecontext/product/ui/ProductDetailPurchase.vue';
import { provideAddToBasketEndpoints } from '@/shared/product/upsell/useProductDetailUpsellAddToBasket';
import BlockList from '@/shared/content/blocks/helpers/BlockList.vue';
import { useAddToBasket } from '@/storecontext/product/purchase/useAddToBasket';
import useBasket from '@/storecontext/basket/useBasket';
import { provideBuyXAndGetYPercent } from '@/shared/checkout/basket/useBuyXAndGetYPercent';


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreProductDetailTile',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as {
    content: StoreProductDetailTileModel
}



const { addToBasket } = useAddToBasket();
const { handleProductTileModelChange } = useProductDetailTileModel();
const { buyXAndGetYPctDiscount } = useBasket();
const content = toRef(props, 'content');
handleProductTileModelChange(content);
provideAddToBasketEndpoints(addToBasket);
provideBuyXAndGetYPercent(buyXAndGetYPctDiscount);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BlockMaxWidthHandler, null, {
      default: _withCtx(() => [
        _createVNode(ProductDetail, null, {
          default: _withCtx(() => [
            _createVNode(ProductDetailPurchase)
          ]),
          _: 1
        }),
        _createVNode(BlockList, {
          blocks: _unref(content).tiles
        }, null, 8, ["blocks"])
      ]),
      _: 1
    })
  ]))
}
}

})